var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",class:{
    'skinClasses': true,
    'persian-font-family': this.$i18n.locale === 'fa'
  },attrs:{"id":"app"}},[_c('b-overlay',{attrs:{"show":_vm.globalLoading,"spinner-variant":"primary","spinner-type":"grow","spinner-small":"","rounded":"sm"}},[_c('notice'),_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('MessageModal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }